<template>
    <div>
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 流向列表 </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
  
      <div class="container">
        <e-search
            :data="queryData"
            :count="8"
            :field-list="fieldList"
            :list-type-info="listTypeInfo"
            :width="listTypeInfo.width"
            @handleFilter="handleSearch"
            @handleReset="handleClear"
            @handleExport="exportFile"
            :btn-style="btnStyle"
        ></e-search>
      </div>
      <div class="container-external">
        <div class="container">
          <TableList
                  ref="tableList"
                  :loading="loading"
                  :table-data="tableData"
                  :table-label="tableLabel"
                  :reserve-selection="false"
                  :index-show="true"
                  maxHeight='500'
                  :table-option="tableOption"
                  @handleButton="handleButton">
          </TableList>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="queryData.pageNum"
              :page-size="queryData.pageSize"
              :total="queryData.pageTotal"
              prev-text="上一页"
              next-text="下一页"
            >
            </el-pagination>
          </div>
        </div>
      </div>
 
    </div>
</template>
  
<script>
  import TableList from "../../components/common/e-table-list";
  import ESearch from '../../components/common/e-search.vue'
  import Api from "../../api/logistics/index";
  import utils from "../../utils/utils";
  export default {
    name: "userManage",
    components: {
      TableList,
      ESearch
    },
    props: {},
    data() {
      return {
        queryData:{
            orderCode:'',
            logisticsNo:'',
            orderShipmentName:'',
            billNo:'',
            purchaseName:'',
            expressCompanyName:'',
            deliveryWay:'',
            transportType:'',
            status:'',
            time:'',
            startTime:'',
            endTime:'',
            pageNum:1,
            pageSize:10,
            pageTotal:0
        },
        fieldList: [
            { label: '订单号', type: 'input', value: 'orderCode', placeholder: '请输入订单号' },
            { label: '发货单号', type: 'input', value: 'logisticsNo', placeholder: '请输入发货单号' },
            { label: '发货单', type: 'input', value: 'orderShipmentName',  placeholder: '请输入发货单' },
            { label: '运单号', type: 'input', value: 'billNo', placeholder: '请输入运单号' },
            { label: '采购商', type: 'input', value: 'purchaseName', placeholder: '请输入采购商' },
            { label: '物流商', type: 'input', value: 'expressCompanyName', placeholder: '请输入物流商' },
            { label: '配送方式', type: 'select', value: 'deliveryWay', placeholder: '请选择配送方式'  ,list: "deliveryWayList"},
            { label: '运输类型', type: 'select', value: 'transportType', placeholder: '请选择运输类型' ,list:'transportTypeList'},
            { label: '配送状态', type: 'select', value: 'status', placeholder: '请选择配送状态' , list: "statusList"},
            { label: '创建时间', type: 'date', value: 'time',  dateType: 'daterange' },
        ],
        listTypeInfo: {
            width: {
                labelWidth: 120,
                itemWidth: 200
            },
            // 配送状态( 1-分拣 2-出库 3-中转 4-签收 5-物流商拒绝 6-待揽收 7-已揽收 8-运输中 9-已签收)
            statusList: [
              { id: 1, name: "分拣" },
              { id: 2, name: "出库" },
              { id: 3, name: "中转" },
              { id: 4, name: "签收" },
              { id: 5, name: "物流商拒绝" },
              { id: 6, name: "待揽收" },
              { id: 7, name: "已揽收" },
              { id: 8, name: "运输中" },
              { id: 9, name: "已签收" },
            ],
            //配送方式（0-自配、1-第三方、2-其他）
            deliveryWayList: [
              { id: 0, name: "自配" },
              { id: 1, name: "第三方" },
              { id: 2, name: "其他" },
            ],
            //：1-快递 2-陆运 3-水运 4-空运 5-多式联运 6-铁路 7-其他
            transportTypeList:[
              { id: 1, name: "快递" },
              { id: 2, name: "陆运" },
              { id: 3, name: "水运" },
              { id: 4, name: "空运" },
              { id: 5, name: "多式联运" },
              { id: 6, name: "铁路" },
              { id: 7, name: "其他" }
            ],
        },
        btnStyle:[
            { icon: null, text: "重置" },
            { icon: null, text: "查询", type: "primary" },
            { icon: null, text: "导出", type: "primary" },
        ],
        loading: false,
        tableData: [],
        tableLabel: [
          { label: "订单号", param: "orderCode", align: "center" , width: "180",},
          { label: "发货单号", param: "logisticsNo", align: "center", width: "180", },
          { label: "发货单", param: "orderShipmentName", align: "center" , width: "180",},
          { label: "运单号", param: "billNo", align: "center" , width: "180",},
          { label: "配送方式", param: "deliveryWayName", align: "center" },
          { label: "运输类型", param: "transportTypeName", align: "center" },
          { label: "配送状态", param: "statusName", align: "center" },
          { label: "采购商", param: "purchaseName", align: "center"  ,width: "220",},
          { label: "物流商", param: "expressCompanyName", align: "center" },
          { label: "发货地", param: "shipAddress", align: "center" ,width: "220",},
          { label: "收货地", param: "receiveAddress", align: "center" ,width: "220"},
          { label: "创建时间", param: "createTime", align: "center" , width: "160",},
          { label: "揽收时间", param: "collectionTime", align: "center" },
          { label: "签收时间", param: "signingTime", align: "center" },
          { label: "最新时间", param: "latestEventTime", align: "center" },
          { label: "最新轨迹", param: "latestEventDesc", align: "center" },
        ],
        tableOption: {
          label: "操作",
          width: "100",
          fixed: "right",
          permission: "0",
          options: [
            {label: "查看",type: "text", methods: "handleCheck"},
          ],
        },
  
      
       
      };
    },
    computed: {},
    
    created() {
      this.getCompanyLogisticsList();
    },
    methods: {
      
      handleSearch(val) {
        Object.assign(this.queryData, val);
        this.queryData.pageNum = 1;
        this.queryData.pageSize = 10;
        this.getCompanyLogisticsList();
      },
      handleClear() {
        this.queryData={
            orderCode:'',
            logisticsNo:'',
            orderShipmentName:'',
            billNo:'',
            purchaseName:'',
            expressCompanyName:'',
            deliveryWay:'',
            transportType:'',
            status:'',
            time:'',
            startTime:'',
            endTime:'',
            pageNum:1,
            pageSize:10,
            pageTotal:0
        }
        this.handleSearch()
      },
      async exportFile() {
        let params = {
           ...this.queryData
        };
        if(params.time){
          params.createTimeStart= utils.dateformate(params.time[0], 'yyyy-MM-dd')
          params.createTimeEnd= utils.dateformate(params.time[1], 'yyyy-MM-dd')
        }
        Api.exportCompanyLogistics(params).then(res => {
            if (res.type == "application/json") {
                utils.fileExportResponseError(res);
            } else {
                utils.downFile(res,'流向列表');
            }
            
 
        });
    },
 
 
      handleButton(val) {
        if (val.methods === "handleCheck") {
          this.handleCheck(val.row);
        }
      },
      handleSizeChange(val) {
        this.queryData.pageSize = val;
        this.queryData.pageNum = 1
        this.getCompanyLogisticsList();
      },
      handleCurrentChange(val) {
        this.queryData.pageNum = val;
        this.getCompanyLogisticsList();
      },
 
     
      handleCheck(val) {
        this.$router.push({path:'/flowDirectionDetail',query:{id:val.logisticsId}})
      },
 
 
      getCompanyLogisticsList() {
        this.loading=true;
        let params = {
           ...this.queryData
        };
        if(params.time){
          params.createTimeStart= utils.dateformate(params.time[0], 'yyyy-MM-dd')
          params.createTimeEnd= utils.dateformate(params.time[1], 'yyyy-MM-dd')
        }
        Api.getCompanyLogisticsList(params).then((res) => {
          this.loading=false;
          this.tableData = res.data.records;
          this.queryData.pageTotal = res.data.total;
        });
      },
  
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container-external {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  .container {
    width: 100%;
  }
  </style>
  